import { Component, HostListener, OnInit } from '@angular/core'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { RestServices } from '../../services/rest.services'
import { AuthService } from '../../services/auth.services'
import * as moment from 'moment'
import { SharedServices } from '../../services/shared.services'

@Component({
    selector: 'ons-page[tabAligner]',
    templateUrl: './aligner.component.html',
    styleUrls: ['./aligner.component.css'],
})
export class AlignerComponent implements OnInit {
    clientId
    clientInfo
    alignerId
    alignerInfo
    todayIs = moment().startOf('day').utc().valueOf()
    todayIsTimeZone0
    arrayMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    arrayWeek = [7, 1, 2, 3, 4, 5, 6]
    arrayYears = []
    displayYear = []
    currentYear = 2018
    activeSegment = 0

    // arrayWeekOfMonth = [1,2,3,4,5];
    constructor(private route: ActivatedRoute, private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
        _sharedService.changeEmittedSource$.subscribe(
            success => {
                let offsetTimezone = new Date().getTimezoneOffset()
                let addTime = (offsetTimezone / 60) * -1
                this.todayIsTimeZone0 = moment().startOf('day').add(addTime, 'hours').valueOf()
                this.clientInfo = success[0]
                this.alignerId = this.clientInfo.activeAligner
                if (this.alignerId) {
                    let resultTest = success[1].find(aigner => aigner._id === this.alignerId)
                    this.alignerInfo = resultTest
                    this.createCelendar()
                }
            },
        )
        this.currentYear = parseInt(moment().startOf('year').format('YYYY'))
        this._sharedService.changeEmitted$.subscribe(
            res => {
                if (res[0] == 'changePageMobileApp' && res[1] === 1) {
                    this.getInfoAligner()
                }
                if (res[0] == 'changePageApp' && res[1] === 1) {
                    this.activeSegment = res[2]
                }
            })
    }

    @HostListener('scroll', ['$event'])
    onElementScroll($event) {
        this.onScroll($event)
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.clientId = id
            // this.getInfoClient();
        })
        // this.getInfoAligner();
        // setTimeout(() => {
        //
        //     this.getInfoAligner();
        // }, 1000);
    }

    activeTab(index, segment) {
        segment.setActiveButton(index)
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
        }, 100)
    }

    getInfoClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map: { [this.clientId]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    // this.listDoctor = success['response']['staff']['paths']['{"roles":"doctor"}'];
                    this.clientInfo = success['response']['client']['map'][this.clientId]
                    this.alignerId = this.clientInfo.activeAligner

                    // this.getInfoAligner();
                },
            )
        })
    }

    getInfoAligner() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map: { [this.clientId]: true },
                },
                clientAligner: {
                    map: { [this.alignerId]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        //
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (this.alignerId) {
                        this.clientInfo = success['response']['client']['map'][this.clientId]
                        // if(this.clientInfo.activeAligner === this.alignerId){
                        this.alignerInfo = success['response']['clientAligner']['map'][this.alignerId]
                        // if(this.alignerInfo){
                        this.createCelendar()
                        // }
                        // }
                        // else{
                        //     this.alignerId = this.clientInfo.activeAligner;
                        //     this.getInfoAligner();
                        //     this.createCelendar();
                        // }
                        // this.alignerInfo = success['response']['clientAligner']['map'][this.alignerId];
                    }
                },
            )
        })
    }

    createCelendar() {
        this.arrayYears = []
        this.displayYear = []
        let startCurentMonth = moment().startOf('month')
        let startCurentYear = moment().startOf('year')
        let endTime = moment(this.alignerInfo.endDate)
        // let endTime = moment('2019-06-06');
        let numYear = endTime.diff(startCurentYear, 'years') + 1
        let doDai = 0
        for (let year = 0; year < numYear; year++) {
            var arrayTime = {
                'Jan': [],
                'Feb': [],
                'Mar': [],
                'Apr': [],
                'May': [],
                'Jun': [],
                'Jul': [],
                'Aug': [],
                'Sep': [],
                'Oct': [],
                'Nov': [],
                'Dec': [],
            }
            var arrayTimeSpliceWeek = {
                'Jan': [],
                'Feb': [],
                'Mar': [],
                'Apr': [],
                'May': [],
                'Jun': [],
                'Jul': [],
                'Aug': [],
                'Sep': [],
                'Oct': [],
                'Nov': [],
                'Dec': [],
            }
            let numWeekOfYear = 60
            if (year === 0 && numYear >= 2) {
                numWeekOfYear = moment().startOf('year').add(1, 'years').diff(startCurentMonth, 'weeks', true) + 1
            } else if (year === 0 && numYear < 2) {
                numWeekOfYear = moment(this.alignerInfo.endDate).diff(startCurentMonth, 'weeks') + 1
            } else if (year === (numYear - 1)) {
                numWeekOfYear = endTime.diff(moment().startOf('year').add(year, 'years'), 'weeks', true) + 1
            }
            // else{
            //
            // }
            //
            for (let i = 0; i < numWeekOfYear; i++) {
                for (let y = 0; y < 7; y++) {
                    if (year === 0) {
                        if (moment().format('YYYY') == moment().startOf('month').day(y + (i * 7)).format('YYYY')) {
                            arrayTime[moment().startOf('month').day(y + (i * 7)).format('MMM')].push(
                                {
                                    day: moment().startOf('month').day(y + (i * 7)).format('DD'),
                                    dayOfWeek: moment().startOf('month').day(y + (i * 7)).isoWeekday(),
                                    firstDay: false,
                                    timeStamp: moment().startOf('month').day(y + (i * 7)).valueOf(),
                                    aligner: this.checkNumAligner(moment().utc().startOf('month').day(y + (i * 7)).valueOf()),
                                },
                            )
                        }
                    } else {
                        if (moment().add(year, 'years').startOf('year').format('YYYY') == moment().add(year, 'years').startOf('year').day(y + (i * 7)).format('YYYY')) {
                            arrayTime[moment().add(year, 'years').startOf('year').day(y + (i * 7)).format('MMM')].push(
                                {
                                    day: moment().add(year, 'years').startOf('year').day(y + (i * 7)).format('DD'),
                                    dayOfWeek: moment().add(year, 'years').startOf('year').day(y + (i * 7)).isoWeekday(),
                                    firstDay: false,
                                    timeStamp: moment().add(year, 'years').startOf('year').day(y + (i * 7)).valueOf(),
                                    aligner: this.checkNumAligner(moment().utc().add(year, 'years').startOf('year').day(y + (i * 7)).valueOf()),
                                },
                            )
                        }
                    }
                }
            }
            // xu ly ngay trong thang
            for (let i = 0; i < this.arrayMonth.length; i++) {
                if (arrayTime[this.arrayMonth[i]].length > 0) {
                    let lastIndex = arrayTime[this.arrayMonth[i]].length - 1
                    var noneDateFirst = []
                    var noneDatelast = []
                    arrayTime[this.arrayMonth[i]][0].firstDay = true
                    if (arrayTime[this.arrayMonth[i]][0].dayOfWeek < 7 && 0 < arrayTime[this.arrayMonth[i]][0].dayOfWeek) {
                        for (let y = 0; y < arrayTime[this.arrayMonth[i]][0].dayOfWeek; y++) {
                            noneDateFirst.push(
                                {
                                    day: '',
                                    dayOfWeek: 8,
                                    firstDay: false,
                                    timeStamp: 0,
                                    aligner: 0,
                                },
                            )
                        }
                    }
                    if (arrayTime[this.arrayMonth[i]][lastIndex].dayOfWeek != 6) {
                        let dayOfWeek = arrayTime[this.arrayMonth[i]][lastIndex].dayOfWeek
                        if (dayOfWeek === 7) {
                            dayOfWeek = 0
                        }
                        for (let y = 6; y > dayOfWeek; y--) {
                            noneDatelast.push(
                                {
                                    day: '',
                                    dayOfWeek: 8,
                                    firstDay: false,
                                    timeStamp: 0,
                                    aligner: 0,
                                },
                            )
                        }
                    }
                    arrayTime[this.arrayMonth[i]] = noneDateFirst.concat(arrayTime[this.arrayMonth[i]])
                    arrayTime[this.arrayMonth[i]] = arrayTime[this.arrayMonth[i]].concat(noneDatelast)
                }
            }
            // chia ngay theo tuan
            for (let i = 0; i < this.arrayMonth.length; i++) {
                if (arrayTime[this.arrayMonth[i]].length > 0) {
                    doDai = doDai + 25
                    for (let y = 0; y < arrayTime[this.arrayMonth[i]].length / 7; y++) {
                        let weeks
                        weeks = arrayTime[this.arrayMonth[i]].slice((y * 7), (y * 7) + 7)
                        arrayTimeSpliceWeek[this.arrayMonth[i]].push(weeks)
                        doDai = doDai + 49
                    }
                }
            }
            this.arrayYears.push(arrayTimeSpliceWeek)
            this.displayYear.push(doDai)
        }
    }

    checkNumAligner(timeStamp) {
        const aligners = this.alignerInfo['aligners']
        for (let i = 0; i < aligners.length; i++) {
            if (timeStamp === aligners[i].startDate) {
                return i + 1
            }
        }
        return 0
    }

    onScroll($event) {
        if ($event) {
            let scrollPosition = 0
            if ($event.srcElement) {
                // Chorme, Safari
                scrollPosition = $event.srcElement.scrollTop
            } else {
                // Firefox
                scrollPosition = $event.target.scrollTop
            }
            const oldYear = parseInt(moment().startOf('year').format('YYYY'))
            for (let i = 0; i < this.displayYear.length; i++) {
                if ((this.displayYear[i] + 548) < (548 + scrollPosition)) {
                    if (this.currentYear <= oldYear) {
                        this.currentYear++

                    }
                    break
                } else {
                    if (this.currentYear > oldYear) {
                        this.currentYear--

                        break
                    }
                }
            }
        }
    }

    activeSegnment(id, segment) {
        this.activeSegment = id
        segment.setActiveButton(id)
    }

    caulatorCurrentAligner(aligner, index) {
        const lastDate = moment(aligner.startDate).add(aligner.interval, aligner.intervalUnit).valueOf()
        return aligner.startDate === this.todayIsTimeZone0 || (aligner.startDate < this.todayIsTimeZone0 && this.todayIsTimeZone0 < lastDate) || index === this.alignerInfo.lastPassedAlignerCount
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/aligner/aligner.component.ts